module.exports = {
	"articleTitle1": "Board of Regents confirms Elizabeth Moje as Dean of the School of ...",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "School of Education",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/government/trump-administration-budget-decrease-higher-education-budget",
	"articleSnippet1": "Feb 16, 2017 ... Elizabeth Moje, associate dean for research and community education, was \nconfirmed as the new dean of the School of Education by the ...",
	"articleSnippet2": "Mar 21, 2017 ... President Donald Trump's budget proposal suggests downsizing the Department \nof Education by 13 percent, or $9 billion, and eliminates ...",
	"totalMisc": 1,
	"articleTitle2": "Trump administration budget to decrease higher education budget ...",
	"address": "610 E University Ave, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160323/msh.NEW_.CSGMeeting.3.22.16.322.jpg?itok=7Zeti_JL",
			"author": "Mazie Hyams",
			"caption": "Kim Travis-Ewing, a Detroit Public Schools social worker, speaks during a panel on the condition of Detroit public schools at the School of Education on Tuesday."
		}
	],
	"position": {
		"lat": 42.2739,
		"lng": -83.7362
	},
	"tips": [
		{
			"text": "There is a free pop machine (in the lounge)!",
			"person": "Maria Robins-Somerville"
		}
	],
	"bathroomrating": [
		{
			"rating": 4,
			"bathroom": "1st Floor"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/schoolofeducation.json
// module id = 968
// module chunks = 0